module.exports = __webpack_public_path__ + "static/media/transfer.0bc796c4.gif";